'use client';

import { type ReactNode } from 'react';

import { cn, type FieldError } from '@/libs';

type FieldsetProps = {
  error?: FieldError;
  success?: boolean;
  label?: string;
  labelClassName?: string;
  required?: boolean;
  helperText?: string;
  className?: string;
  children?: ReactNode;
} & React.LabelHTMLAttributes<HTMLLabelElement>;

export const FormField = ({
  error,
  success,
  label,
  labelClassName,
  required,
  helperText,
  children,
  className,
  ...props
}: FieldsetProps) => {
  return (
    <label className={cn('flex flex-col gap-1 w-full', className)} {...props}>
      {label && (
        <div className={cn('text-sm font-medium text-foreground', labelClassName)}>
          {label}
          {required && (
            <span className="text-error ml-1" aria-hidden="true">
              *
            </span>
          )}
        </div>
      )}

      <div className={cn('relative flex gap-1')}>{children}</div>

      {(helperText || error?.message) && (
        <span
          className={cn(
            'text-xs',
            error
              ? 'text-error'
              : success
                ? 'text-secondary-text'
                : 'text-muted-foreground',
          )}
        >
          {error?.message ?? helperText ?? ''}
        </span>
      )}
    </label>
  );
};
